import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { fetchWikiContent } from '../../services/cmsService';

const WikiArticle = ({ articleId }) => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        setLoading(true);
        const data = await fetchWikiContent();
        const foundArticle = data.find((item) => item.name === articleId);
        if (!foundArticle) {
          throw new Error('Articolul nu a fost găsit.');
        }
        setArticle(foundArticle);
      } catch (err) {
        setError(err.message || 'A apărut o eroare.');
      } finally {
        setLoading(false);
      }
    };

    loadArticle();
  }, [articleId]);

  if (loading) {
    return <p className="text-center text-gray-500">Se încarcă...</p>;
  }

  if (error) {
    return (
      <div className="text-center text-gray-500">
        <h2 className="text-2xl font-semibold">Eroare</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <>
      {article && (
        <>
          {/* Schema.org Metadata */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: DOMPurify.sanitize(article.title, { ALLOWED_TAGS: [] }),
                articleSection: DOMPurify.sanitize(article.subcategory, { ALLOWED_TAGS: [] }),
                url: `${import.meta.env.VITE_DOMAIN}/wiki/${encodeURIComponent(article.name)}`,
                description: DOMPurify.sanitize(article.content, { ALLOWED_TAGS: [] }).substring(0, 150),
                author: {
                  '@type': 'Organization',
                  name: 'Licitatii-Constructii',
                },
                publisher: {
                  '@type': 'Organization',
                  name: 'Licitatii-Constructii',
                  logo: {
                    '@type': 'ImageObject',
                    url: `${import.meta.env.VITE_BASE_URL}/assets/logo.png`,
                  },
                },
              }),
            }}
          />

          {/* Content */}
          <article className="prose prose-blue max-w-full">
            <h1 className="text-4xl font-bold text-gray-800 mb-3">
              {article.title}
            </h1>
            <h2 className="text-lg text-gray-500 mb-6">
              {article.subcategory}
            </h2>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.content) }} />
          </article>
        </>
      )}
    </>
  );
};

export default WikiArticle;
